export const SET_SEARCH = "SET_SEARCH";

export const SETSEARCH = (search: string, data: any) => {
  return {
    type: SET_SEARCH,
    payload: { search, data },
  };
};

const initialState: object = {
  filterCategory: [],
  search: "",
};

const reducer = (state = initialState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case SET_SEARCH:
      return {
        ...state,
        search: payload?.search,
        filterCategory: payload?.data,
      };
    default:
      return state;
  }
};

export default reducer;
